import { useEffect, useState } from 'react';
import { Container, Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getSlotGamesReq } from 'stores/auth/services';
import Loading from 'components/general/loading';
import SlotItem from './SlotItem';
import _ from 'lodash';

export default function Slot() {
  const { t } = useTranslation('translations');
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const getData = async () => {
    try {
      setLoading(true);
      const response = await getSlotGamesReq();

      // Extract popular games and providers from response
      const popularGames = response.popularGames?.popularGames || [];
      const popularProviders = response.popularGames?.popularProviders || [];

      const tempProviders = [
        {
          title: t('allproviders'),
          key: 'allproviders',
          games: []
        }
      ];
      const games = [...response.extraGames, ...Object.values(response.games)];
      response.providers = _.uniqBy(games, 'vendor').map((g) => g.vendor);
      tempProviders.push(
        ...response.providers.map((p) => ({
          title: p,
          key: p,
          games: []
        }))
      );
      games.forEach((game) => {
        if (popularGames.indexOf(game.id_game) > -1) {
          tempProviders[0].games.push(game);
        }
        const providerObjIndex = tempProviders.findIndex((p) => p.key === game.vendor);
        if (providerObjIndex > -1) {
          tempProviders[providerObjIndex].games.push(game);
        }
      });

      // Sort games in allproviders section according to popularGames order
      tempProviders[0].games.sort((a, b) => {
        const indexA = popularGames.indexOf(a.id_game);
        const indexB = popularGames.indexOf(b.id_game);
        return indexA - indexB;
      });

      // Sort providers according to popularProviders array
      tempProviders.sort((a, b) => {
        const indexA = popularProviders.indexOf(a.key);
        const indexB = popularProviders.indexOf(b.key);

        // If both providers are in the popular providers array, sort by their position
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        // If only one is in the popular providers array, prioritize it
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        // If neither is in the popular providers array, sort alphabetically
        return a.title.localeCompare(b.title);
      });

      tempProviders.forEach((p) => {
        p.title = p.title.toUpperCase();
      });
      setProviders(tempProviders);
      setSelectedProvider(tempProviders[0]);
    } catch (error) {
      console.log(error);
      // error
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const filterProviderBySearch = (provider) => {
    return search.trim() !== ''
      ? provider.games.filter((g) => g.display_name.toLowerCase().includes(search.toLowerCase()))
          .length > 0
      : true;
  };

  const filterProviderGamesBySearch = (game) => {
    return search.trim() !== ''
      ? game.display_name.toLowerCase().includes(search.toLowerCase())
      : true;
  };

  if (loading) return <Loading message={t('loading_games')} />;

  return (
    <Container
      id="slot-container"
      style={{ backgroundColor: '#171717', color: 'white', maxWidth: '100%' }}>
      <div className="row py-2 gy-3">
        <div className="col-6">
          <Form.Control
            type="text"
            placeholder={t('search_games')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-6">
          <Dropdown align={'end'}>
            <Dropdown.Toggle
              variant=""
              id="dropdown-providers"
              className="w-100 flex-center border">
              <span style={{ color: 'white' }} className="w-100 text-start text-capitalize">
                {selectedProvider?.title}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: 300, overflowY: 'auto' }}>
              {providers.map((provider) => (
                <Dropdown.Item
                  key={provider.key}
                  onClick={() => setSelectedProvider(provider)}
                  className="text-capitalize">
                  {provider.title}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <hr className="col-12 mb-0" />
        {providers
          .filter((p) => {
            if (selectedProvider?.key === 'allproviders') {
              return true; // Show all providers when "allproviders" is selected
            }
            return p.key === selectedProvider?.key; // Show only selected provider
          })
          .filter((p) => filterProviderBySearch(p))
          .map((provider, i) => (
            <div className="col-12 col-md-4" key={`slot-item-${provider.key}`}>
              <SlotItem
                provider={provider.title}
                games={provider.games.filter((g) => filterProviderGamesBySearch(g))}
              />
              {i !== providers.length - 1 && <hr className="mb-0 d-block d-md-none" />}
            </div>
          ))}
      </div>
    </Container>
  );
}
